import NotFoundAr from "./notFoundAr";
function NotFound_AR(){
    return (
        <>
        <NotFoundAr />
        </>
    )
}


export default NotFound_AR